import React, { useEffect, useState } from "react";
import "./InternalProjectLinks.css";

function InternalProjectLinks() {
  const [links, setLinks] = useState([]);

  useEffect(() => {
    fetch("/internalProjectLinks.json")
      .then((res) => res.json())
      .then((data) => setLinks(data))
      .catch((err) => console.error("Failed to load links", err));
  }, []);

  return (
    <div className="page">
      <div className="card">
        <h1>Internal Project Portals</h1>
        <p className="subtitle">Quick access to internal applications</p>

        {links.map((item) => (
          <a
            key={item.name}
            href={item.url}
            target="_blank"
            rel="noopener noreferrer"
            className="project"
          >
            <div className="badge">{item.name}</div>
            <div className="info">
              <div className="title">{item.name}</div>
              <div className="desc">{item.description}</div>
            </div>
            <div className="arrow">→</div>
          </a>
        ))}
      </div>
    </div>
  );
}

export default InternalProjectLinks;
